'use client';

import type { ReactNode } from 'react';
import { useInView } from '@/lib/hooks/useInView';

type RevealProps = {
  children: ReactNode;
  className?: string;
  /** ms, for staggering multiple reveals in the same section. */
  delayMs?: number;
  /** Which edge it slides in from. Defaults to sliding up from below. */
  direction?: 'up' | 'left' | 'right';
};

const HIDDEN_CLASSES = {
  up: 'translate-y-10 opacity-0',
  left: '-translate-x-12 opacity-0',
  right: 'translate-x-12 opacity-0',
};

/** Fades + slides content into place each time it scrolls into view. */
export default function Reveal({
  children,
  className = '',
  delayMs = 0,
  direction = 'up',
}: RevealProps) {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delayMs}ms` }}
      className={`transition-all duration-700 ease-out ${
        inView ? 'translate-x-0 translate-y-0 opacity-100' : HIDDEN_CLASSES[direction]
      } ${className}`}
    >
      {children}
    </div>
  );
}
